import { useState } from "react";

export const useAsyncSupabaseRequest = () => {
  const [isLoading, setIsLoading] = useState<boolean | undefined>(undefined);

  const fetchData = async (filter: string, requests: any[]) => {
    setIsLoading(true);
    const responses = await Promise.all(
      requests.map((request) => request(filter))
    );
    setIsLoading(false);

    const fetchedData = responses[0].data;

    for (let i = 1; i < responses.length; i++) {
      const { data } = responses[i];

      fetchedData.push(...data);
    }

    return fetchedData;
  };

  return {
    isLoading,
    setIsLoading,
    fetchData,
  };
};
